import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircleDashed = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 10 10",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 5,
		cy: 5,
		r: 4.445,
		stroke: "currentColor",
		strokeDasharray: "2 2",
		strokeWidth: 1.11
	})
});
export default SvgCircleDashed;
